module.exports = __webpack_public_path__ + "static/media/hospital.9afcd50d.svg";